import { TransactionOriginatorType } from '../enums/transactionOriginatorType'

export const getBankPaymentIds = (modifierReferences?: Array<string | null | undefined>): string[] =>
  (modifierReferences ?? []).flatMap((modifierReference) => {
    const [modifierType, modifierId] = (modifierReference ?? '').split(':')

    return modifierType === TransactionOriginatorType.BankPayment && modifierId ? [modifierId] : []
  })
